import React from "react";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import _ from "lodash";
import Baobab from "baobab";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import deepmerge from "deepmerge";

import * as actions from "../actions/actions";
import { getJwtToken } from "../actions/user";
import env from "../constants/env";
import PlayerPaths from "../constants/paths/playerPaths";
import webPlayerState from "../state/webPlayerState";
import ambifiWebPlayerConfig from "../constants/webPlayerConfig/ambifi";
import state from "../state/state";
import PlayerZoid from "../components/player/playerZoid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { /*isDev, */getFirstLevelItemType } from "../utils/utils";
import { hasBankRefReference } from "../utils/bankRefUtils";

class ChecklistPreviewInline extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		this.webPlayerRef = React.createRef();
		this.previewLoadSignature = this.getPreviewLoadSignature(props);
		this.state = {
			fallbackToTop: false
		};
		this.initWebPlayerState(props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		console.log("DOING SOMETHING WITH PROPS");
		console.log(nextProps);
		this.resetPreviewLoadFallback(nextProps);
		this.initWebPlayerState(nextProps);
	}

	getPreviewLoadSignature(props = this.props) {
		const checklistId = _.get(props, "previewChecklist.checklist.id", "");
		const session = _.get(props, "previewChecklist.session", "");
		const showInline = _.get(props, "previewChecklist.showInline", false);
		return `${checklistId}:${session}:${showInline}`;
	}

	resetPreviewLoadFallback(nextProps = this.props) {
		const nextSignature = this.getPreviewLoadSignature(nextProps);
		if (nextSignature !== this.previewLoadSignature) {
			this.previewLoadSignature = nextSignature;
			if (this.state.fallbackToTop) {
				this.setState({ fallbackToTop: false });
			}
		}
	}

	getEffectiveChecklist() {
		const checklist = _.get(this.props, "previewChecklist.checklist", null);
		if (!_.isObject(checklist) || this.state.fallbackToTop !== true) {
			return checklist;
		}

		const fallbackChecklist = _.cloneDeep(checklist);
		delete fallbackChecklist.selected;
		delete fallbackChecklist.selectedListIndex;
		return fallbackChecklist;
	}

	handleOnLoadError(err) {
		console.error("Unable to load inline preview player", err);
		actions.hideDocumentsSpinner();

		if (this.state.fallbackToTop !== true) {
			this.setState({ fallbackToTop: true });
		}
	}

	handleExit() {
		this.props.dispatch(actions.closeChecklistInline);
	}

	initWebPlayerState(props) {
		let newWebPlayerState = new Baobab(_.cloneDeep(webPlayerState.get()));
		// newWebPlayerState.set(["player", "readOnly"], true);
		newWebPlayerState.set(["user"], props.user);
		newWebPlayerState.set(["_config"], { showControls: false, showHeaderPanel: true });

		newWebPlayerState.set(["timerTemplates"], _.cloneDeep(state.get(["timerTemplates"])));
		newWebPlayerState.set(["appPreferences", "checkbarLocation"], "hidden");

		this.newWebPlayerState = newWebPlayerState.get();
	}

	render() {
		if (this.props.previewChecklist && this.props.previewChecklist.showModal) {
			return null;
		}

		let orgPreferences = {};
		if (this.props.selectedOrg) {
			const { preferences } = this.props.selectedOrg;
			orgPreferences = _.pick(preferences, ["tts-phonetics", "theme", "stylesheet", "fonts", "playlists"]); // Limit this for now to prevent very large props
		}

		if (this.props.orgPreferences) {
			// Providing overrides
			orgPreferences = deepmerge.all([orgPreferences, this.props.orgPreferences]);
		}

		// const disableVoice = !!this.props.disableVoice;

		const effectiveChecklist = this.getEffectiveChecklist();
		const addtlProps = {};
		if (this.props.previewChecklist && _.isNumber(this.props.previewChecklist.session)) {
			addtlProps.key = `cache-key-${this.props.previewChecklist.session}-${this.state.fallbackToTop ? "top" : "selected"}`;
		}
		let credentials = "";
		if (window.awsTempCredentials) {
			credentials = btoa(JSON.stringify({
				iid: _.get(this.props, "user.identityId", ""),
				sak: window.awsTempCredentials.secretAccessKey,
				ak: window.awsTempCredentials.accessKeyId,
				st: window.awsTempCredentials.sessionToken
			}));
		}

			const previewPlayerConfig = {
				...ambifiWebPlayerConfig,
				debugVarsInspector: true,
				persistence: {
				...(ambifiWebPlayerConfig.persistence || {}),
				useInjectedActivities: true,
				previewUploads: {
					enabled: true,
						rootFolder: "previewAssets",
						activityId: _.get(this.props, "previewChecklist.checklist.id", "preview"),
						sessionId: _.isNumber(_.get(this.props, "previewChecklist.session")) ? String(this.props.previewChecklist.session) : "preview",
						skipBackgroundProcessing: true
					}
				}
			};
			const launchActivity = effectiveChecklist && !_.isEmpty(effectiveChecklist) && effectiveChecklist.hasOwnProperty("children") && _.isArray(effectiveChecklist.children) && !_.isEmpty(effectiveChecklist.children);
			const invalidActivity = effectiveChecklist && !_.isEmpty(effectiveChecklist) && !launchActivity;
			let activity = launchActivity ? <div className="ambifi-web-player-container"><PlayerZoid
				activities={[effectiveChecklist]}
				activityId={effectiveChecklist.id}
				config={previewPlayerConfig}
			env={_.cloneDeep(env)}
			drive={{ guidToResource: this.props.drive.guidToResource }}
			state={this.newWebPlayerState}
			credentials={credentials}
			jwt={getJwtToken()}
			componentRequester={"ambifiCloud"}
			onExit={this.handleExit}
			onLoad={() => actions.hideDocumentsSpinner()}
			onLoadError={this.handleOnLoadError}
			onSelectionChanged={(selection) => {
				// WE NOW HAVE SELECTED NODE TYPE

				console.log("*!*!*! SELECTION CHANGED", selection);
				console.log("*!*!*! SELECTED NODE PATH", state.get(["selectedNodePath"]));

				const oldSelectedNodePath = state.select("selectedNodePath").get();
				const oldVirtualOutlineSelection = state.get(["appState", "previewChecklist", "virtualOutlineSelection"]);
				const pendingVirtualSelectionPath = ["appState", "previewChecklist", "pendingVirtualSelection"];
				const pendingVirtualSelection = state.get(pendingVirtualSelectionPath);

				const isValidIndex = (value) => Number.isInteger(value) && value >= 0;
				const getRequiredIndex = (value) => isValidIndex(value) ? value : null;
				const pathEquals = (pathA, pathB) => _.isEqual(pathA || [], pathB || []);
				const firstLevel = getFirstLevelItemType(state.get(["tree", "root"]));
				const selectedNodeType = _.get(selection, "selectedNodeType", "");
				const listIndex = getRequiredIndex(_.get(selection, "listIndex", null));
				const sectionIndex = getRequiredIndex(_.get(selection, "sectionIndex", null));
				const itemIndex = getRequiredIndex(_.get(selection, "itemIndex", null));
				let selectedNodePath;
				let selectedListPath = ["tree", "root"];
				if (firstLevel === null) {
					selectedNodePath = ["tree", "root"];
				} else if (firstLevel && firstLevel.startsWith("item")) {
					if (selectedNodeType === "item" && itemIndex !== null) {
						selectedNodePath = ["tree", "root", "children", itemIndex];
					} else if (selectedNodeType === "checklist") {
						selectedNodePath = ["tree", "root"];
					} else {
						return;
					}
				} else if (firstLevel === "section") {
					if (selectedNodeType === "checklist") {
						selectedNodePath = ["tree", "root"];
					} else if (selectedNodeType === "section") {
						if (sectionIndex === null) {
							return;
						}
						selectedNodePath = ["tree", "root", "children", sectionIndex];
					} else if (selectedNodeType === "item") {
						if (sectionIndex === null || itemIndex === null) {
							return;
						}
						selectedNodePath = ["tree", "root", "children", sectionIndex, "children", itemIndex];
						selectedListPath = ["tree", "root", "children", sectionIndex];
					} else {
						return;
					}
				} else {
					if (selectedNodeType === "checklist") {
						selectedNodePath = ["tree", "root"];
					} else if (selectedNodeType === "list") {
						if (listIndex === null) {
							return;
						}
						selectedNodePath = ["tree", "root", "children", listIndex];
					} else if (selectedNodeType === "section") {
						if (listIndex === null || sectionIndex === null) {
							return;
						}
						selectedNodePath = ["tree", "root", "children", listIndex, "children", sectionIndex];
					} else if (selectedNodeType === "item") {
						if (listIndex === null || sectionIndex === null || itemIndex === null) {
							return;
						}
						selectedNodePath = ["tree", "root", "children", listIndex, "children", sectionIndex, "children", itemIndex];
						selectedListPath = ["tree", "root", "children", listIndex];
					} else {
						return;
					}
				}

				// Keep the exact outline node selected. We still compute the concrete
				// item path for preview-selection handshakes used by referenced trees.
				let previewItemPath = null;
				if (firstLevel && firstLevel.startsWith("item")) {
					if (itemIndex !== null) {
						previewItemPath = ["tree", "root", "children", itemIndex];
					}
				} else if (firstLevel === "section") {
					if (sectionIndex !== null && itemIndex !== null) {
						previewItemPath = [
							"tree",
							"root",
							"children",
							sectionIndex,
							"children",
							itemIndex
						];
					}
				} else if (firstLevel) {
					if (listIndex !== null && sectionIndex !== null && itemIndex !== null) {
						previewItemPath = [
							"tree",
							"root",
							"children",
							listIndex,
							"children",
							sectionIndex,
							"children",
							itemIndex
						];
					}
				}
				if (!selectedNodePath || selectedNodePath.length === 0) {
					return;
				}

				let matchedPendingVirtualSelection = false;
				if (pendingVirtualSelection && _.isObject(pendingVirtualSelection)) {
					const now = Date.now();
					const expiresAt = Number(pendingVirtualSelection.expiresAt || 0);
					const expectedTreePath = Array.isArray(pendingVirtualSelection.expectedTreePath)
						? pendingVirtualSelection.expectedTreePath
						: [];
					if (expiresAt > 0 && now > expiresAt) {
						state.unset(pendingVirtualSelectionPath);
					} else if (expectedTreePath.length > 0) {
						const candidatePaths = [selectedNodePath];
						if (Array.isArray(previewItemPath) && previewItemPath.length > 0) {
							candidatePaths.push(previewItemPath);
						}
						const matchesExpectedPath = candidatePaths.some((path) => pathEquals(path, expectedTreePath));
						if (!matchesExpectedPath) {
							return;
						}
						matchedPendingVirtualSelection = true;
						state.unset(pendingVirtualSelectionPath);
					} else {
						state.unset(pendingVirtualSelectionPath);
					}
				}

				// Ensure visible where possible.
				const selectedListCursor = state.select(selectedListPath);
				if (selectedListCursor && selectedListCursor.exists && selectedListCursor.exists()) {
					const selectedListNode = selectedListCursor.get();
					if (selectedListNode && selectedListNode.expanded !== true) {
						actions.handleExpandNodeAll(selectedListCursor);
					}
				}

				const resolvedSelectedNodePath = actions.handleSelectNodeAtPath(
					state,
					selectedNodePath,
					null,
					{
						preserveVirtualSelection: true
					}
				);
				const resolvedSelectedNode = state.get(resolvedSelectedNodePath);
				const resolvedNodeType = _.get(resolvedSelectedNode, "entity.type", "");
				const resolvedIsBankRefContainer =
					(resolvedNodeType === "list" || resolvedNodeType === "section") &&
					hasBankRefReference(_.get(resolvedSelectedNode, "entity", null));
				const resolvedAnchorPath = Array.isArray(resolvedSelectedNodePath) ? resolvedSelectedNodePath.join(",") : "";
				const oldVirtualForResolvedAnchor = oldVirtualOutlineSelection &&
					oldVirtualOutlineSelection.anchorPath === resolvedAnchorPath &&
					Array.isArray(oldVirtualOutlineSelection.virtualPath)
					? oldVirtualOutlineSelection.virtualPath
					: [];
				let virtualPath = [];
				if (matchedPendingVirtualSelection && oldVirtualForResolvedAnchor.length > 0) {
					virtualPath = oldVirtualForResolvedAnchor;
				} else if (resolvedIsBankRefContainer && resolvedNodeType === "list") {
					if (
						selectedNodeType === "item" &&
						sectionIndex !== null &&
						itemIndex !== null
					) {
						virtualPath = [sectionIndex, itemIndex];
					} else if (
						selectedNodeType === "section" &&
						sectionIndex !== null
					) {
						if (itemIndex !== null) {
							virtualPath = [sectionIndex, itemIndex];
						} else if (
							oldVirtualForResolvedAnchor.length === 2 &&
							oldVirtualForResolvedAnchor[0] === sectionIndex
						) {
							virtualPath = oldVirtualForResolvedAnchor;
						}
					} else if (selectedNodeType === "list" || selectedNodeType === "checklist") {
						if (oldVirtualForResolvedAnchor.length === 2) {
							virtualPath = oldVirtualForResolvedAnchor;
						}
					}
				} else if (resolvedIsBankRefContainer && resolvedNodeType === "section") {
					if (selectedNodeType === "item" && itemIndex !== null) {
						virtualPath = [itemIndex];
					} else if (selectedNodeType === "section" || selectedNodeType === "checklist") {
						if (itemIndex !== null) {
							virtualPath = [itemIndex];
						} else if (oldVirtualForResolvedAnchor.length === 1) {
							virtualPath = oldVirtualForResolvedAnchor;
						}
					}
				}

				const nextVirtualOutlineSelection = virtualPath.length > 0 ? {
					anchorPath: resolvedAnchorPath,
					virtualPath,
					selection: _.pick(selection, ["selectedNodeType", "listIndex", "sectionIndex", "itemIndex"])
				} : null;
				const shouldRetainExistingVirtualSelection =
					!nextVirtualOutlineSelection &&
					oldVirtualOutlineSelection &&
					oldVirtualOutlineSelection.anchorPath === resolvedAnchorPath &&
					(resolvedNodeType === "list" || resolvedNodeType === "section");

				if (nextVirtualOutlineSelection) {
					if (!_.isEqual(oldVirtualOutlineSelection || null, nextVirtualOutlineSelection)) {
						state.set(["appState", "previewChecklist", "virtualOutlineSelection"], nextVirtualOutlineSelection);
					}
				} else if (shouldRetainExistingVirtualSelection) {
					// Keep existing virtual selection when player emits a container-level callback
					// before/without a concrete child index update.
				} else if (oldVirtualOutlineSelection !== undefined) {
					state.unset(["appState", "previewChecklist", "virtualOutlineSelection"]);
				}

				// Scroll into view only when selection path actually changed.
				if (!pathEquals(resolvedSelectedNodePath, oldSelectedNodePath)) {
					setTimeout(() => {
						actions.scrollSelectedNodeIntoView();
					}, 1500);
				}
			}}
			disableVoice={true}
			// inlineShowMode
			orgPreferences={orgPreferences}
			stateUpdates={this.props.stateUpdates}
			inlinePlayer={true}
			allVisible={this.props.allVisible}
			debugVarsInspector={true}
			ref={this.webPlayerRef}
			{...addtlProps} /></div> : invalidActivity ?
			<div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", color: "red" }}>The selected activity seems to be empty, please try another.</div> :
			<div style={{ backgroundColor: "#444444", color: "white", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", fontSize: 20, padding: 25 }}>
				{/* {(this.props.urlParams.livePreview || isDev()) && */}
				<div style={{ fontWeight: "bold" }}>
					<p>Click the flux capacitor <FontAwesomeIcon size="lg" icon={["far", "flux-capacitor"]} /> for a live preview! Currently in Beta. If you see issues, just click <FontAwesomeIcon icon="sync" />.</p>
					<p>If 1.21 gigawatts is too much power for your machine, you can manually preview after making edits by clicking <FontAwesomeIcon icon="sync" />.</p>
					<p>The All Visible action <FontAwesomeIcon icon="eye" /> toggles between showing all content even if it is not visible and honoring the visibility rules.</p>
					<p style={{ fontSize: "smaller", fontWeight: "lighter", color: "goldenrod" }}><i>Note: You can preview changes without saving. This allows you to experiment. When you are happy with your changes make sure to click <FontAwesomeIcon icon="save" />.</i></p>
				</div>
				{/* } */}
				{/* {(!this.props.urlParams.livePreview && !isDev()) &&
					<div style={{ fontWeight: "bold" }}>
						<p>You can manually preview after making edits by clicking <FontAwesomeIcon icon="sync" />.</p>
						<p style={{ fontSize: "smaller", fontWeight: "lighter", color: "goldenrod" }}><i>Note: You can preview changes without saving. This allows you to experiment. When you are happy with your changes make sure to click <FontAwesomeIcon icon="save" />.</i></p>
					</div>
				} */}
			</div>;

		// const component =
		// 	<div style={{ width: "100%" }}>
		// 		{this.props.previewChecklist.showInline ?
		// 			<div width="100%">{activity}</div> :
		// 			"Click to reload"}

		// 	</div>;

		return activity;
	}
}

export default branch({
	user: ["user"],
	drive: ["drive"],
	player: PlayerPaths.ROOT,
	selectedActivityId: PlayerPaths.SELECTED_ACTIVITY_ID,
	appCapabilities: ["appCapabilities"],
	selectedOrg: ["selectedOrg"],
	previewChecklist: ["appState", "previewChecklist"],
	stateUpdates: ["appState", "stateUpdates"],
	allVisible: ["appState", "previewChecklist", "allVisible"],
	urlParams: ["appState", "urlParams"]
}, ChecklistPreviewInline);
